// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero-section_wrapper__TLKBZ","imageContainer":"hero-section_imageContainer__8OXFt"};